import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  Typography
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

export type TeamSessionLimitDialogProps = {
  open: boolean;
  currentUsers: number;
  maxUsers: number;
  onClose: () => void;
};

export const TeamSessionLimitDialog: React.FC<TeamSessionLimitDialogProps> = ({
  open,
  currentUsers,
  maxUsers,
  onClose
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <WarningIcon color="warning" sx={{ mr: 1, fontSize: 28 }} />
          Team Session Limit Reached
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          <Typography variant="body1" paragraph>
            <strong>Team session limit reached: {currentUsers}/{maxUsers} concurrent users.</strong>
          </Typography>
          <Typography variant="body1" paragraph>
            Please try again later when another team member finishes their session.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            If this happens frequently, report it to your team admin and suggest increasing the concurrent user limit.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TeamSessionLimitDialog;
